<template>
  <div>
    <ContentPage headerText="Book Your MOT">
      <p>
        Ensure your vehicle meets the legal standards for roadworthiness with
        our comprehensive MOT testing service.
      </p>
    </ContentPage>

    <div class="content">
      <div class="container" :style="loaded ? 'opacity: 100': 'opacity: 0'">
        <div id="tm-ob"></div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentPage from '@/components/partials/ContentPage.vue'

export default {
  name: 'book-your-mot',
  components: {
    ContentPage
  },
  data () {
    return {
      loaded: false,
      techManScriptEl: null,
      intervalId: null
    }
  },
  mounted () {
    this.addTechMan()
  },
  beforeDestroy () {
    this.removeTechMan()
  },
  methods: {
    addTechMan () {
      this.intervalId = setInterval(() => {
        if (document.querySelector('iframe + #tm-ob')) {
          this.loaded = true
          clearInterval(this.intervalId)
        }
      }, 1000)

      /*
          This is added as the prerender uses the http protocol causing the
          script to be loaded via http which causes an error in product
      */
      if (document.location.protocol === 'http:' && process.env.NODE_ENV !== 'development') {
        return
      }

      window.obWidth = '100%'
      window.obHeight = '850px'
      window.obUrl = 'snetterton.wsptm.com'

      const b = document.createElement('script')
      const s = document.getElementsByTagName('script')[0]

      b.type = 'text/javascript'
      b.async = true
      b.src =
        (document.location.protocol === 'https:' ? 'https://' : 'http://') +
        window.obUrl +
        '/integrate.js'

      this.techManScriptEl = b

      s.parentNode.insertBefore(b, s)
    },

    removeTechMan () {
      clearInterval(this.intervalId)

      if (this.techManScriptEl) {
        this.techManScriptEl.remove()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  min-height: 850px;

  transition: opacity 0.5s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/BookYourMOT.vue